import { useState } from 'react';

import { CustomFieldBlueprint, FieldBlueprint, FieldTypes } from '@zinnia/form-engine-sdk';

import { FieldDataHookReturnValue, useCastBlueprintToFieldType } from '../../Helpers/helperTypes';

export type CustomFieldData = Pick<CustomFieldBlueprint, 'customName'>;

export type SignatureFieldSetters = {
  setCustomName: React.Dispatch<React.SetStateAction<CustomFieldData['customName']>>;
};

export function useCustomFieldData({
  initialData,
}: {
  initialData?: Partial<FieldBlueprint>;
}): FieldDataHookReturnValue<CustomFieldData, SignatureFieldSetters> {
  const initialDataAsCustomField = useCastBlueprintToFieldType<CustomFieldBlueprint>(FieldTypes.custom, initialData);

  const [customName, setCustomName] = useState<CustomFieldData['customName']>(
    initialDataAsCustomField?.customName || '',
  );

  return {
    data: {
      customName,
    },
    setters: {
      setCustomName,
    },
    clearData: () => {
      setCustomName(initialDataAsCustomField?.customName || '');
    },
  };
}
